
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class OsLoadingIndicator extends Vue {
  get loadingLabel(): string {
    return (this as any).$tc('control.logo_uploader.loading_text');
  }
}
